/**
 * AJAX filter/sort/pager for the catalog category/subcategory listing.
 * Progressively upgrades plain <a href> links (works without JS) into a
 * fetch-and-swap of the results block, with history.pushState for the URL.
 */
(() => {
    const SWAP_SELECTOR = '[data-catalog-results]';
    const LINK_SELECTOR = '.catalog-filter, .catalog-filters__reset, .catalog-pager__page, .catalog-pager__arrow, .catalog-sort__item';
    const SWAP_FADE_MS = 160; // matches --transition-fast in catalog.css

    function setFiltersOpen(panel, open) {
        if (!panel) {
            return;
        }
        panel.classList.toggle('is-open', open);
        panel.querySelector('[data-catalog-filters-toggle]')?.setAttribute('aria-expanded', String(open));
    }

    async function swapTo(url) {
        const oldRoot = document.querySelector(SWAP_SELECTOR);
        if (!oldRoot) {
            window.location.href = url;
            return;
        }
        oldRoot.classList.add('is-swapping');
        const filtersWereOpen = !!oldRoot.querySelector('[data-catalog-filters].is-open');

        try {
            const [response] = await Promise.all([
                fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
                new Promise((resolve) => setTimeout(resolve, SWAP_FADE_MS)),
            ]);
            if (!response.ok) {
                throw new Error(`Unexpected status ${response.status}`);
            }
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const newRoot = parsed.querySelector(SWAP_SELECTOR);
            if (!newRoot) {
                throw new Error('Missing [data-catalog-results] in response');
            }

            newRoot.classList.add('is-swapping');
            if (filtersWereOpen) {
                setFiltersOpen(newRoot.querySelector('[data-catalog-filters]'), true);
            }
            oldRoot.replaceWith(newRoot);
            window.history.pushState({}, '', url);
            newRoot.scrollIntoView({ behavior: 'smooth', block: 'start' });

            void newRoot.offsetHeight; // force reflow so opacity:0 is committed before we transition to visible
            newRoot.classList.remove('is-swapping');
        } catch (error) {
            console.warn('Catalog results swap failed, falling back to full navigation:', error);
            oldRoot.classList.remove('is-swapping');
            window.location.href = url;
        }
    }

    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-catalog-filters-toggle]');
        if (toggle) {
            const panel = toggle.closest('[data-catalog-filters]');
            setFiltersOpen(panel, !panel.classList.contains('is-open'));
            return;
        }
        const link = event.target.closest(LINK_SELECTOR);
        if (!link || !link.closest(SWAP_SELECTOR)) {
            return;
        }
        const url = link.getAttribute('href');
        if (!url) {
            return;
        }
        event.preventDefault();
        swapTo(url);
    });

    window.addEventListener('popstate', () => {
        window.location.reload();
    });
})();
